import React, { useRef, useState, useEffect } from "react"
import { useTranslation } from 'react-i18next';

import PromptTranslate from "../../PromptTranslate/PromptTranslate";

import { useHookStore } from "../../../hook-store/store"
// import { resizeImageFile } from '../../utils/image/image-utils';
import { marks } from '../../../utils/marks';

import "./DiffusionOptionsDesc.css";

// import IpaImage1 from "../../../image/for-iopaint/option-description/ipa/ipa-input-h100.jpeg";
// import IpaImage2 from "../../../image/for-iopaint/image-prompt/statue-h200.png";
// import IpaImage3 from "../../../image/for-iopaint/option-description/ipa/ipa-mask-h100.jpeg";
// import IpaImage4 from "../../../image/for-iopaint/option-description/ipa/ipa-output-h100.jpg";


import ex5InputImage from '../../../image/for-iopaint/boy-man-150.png';
import ex5MaskImage from '../../../image/for-iopaint/boy-man-mask-h150.png';
import ex5InpaintImage from '../../../image/for-iopaint/boy-man-cleanup-h150.png';
import ex5InpaintImage2 from '../../../image/for-iopaint/boy-man-cleanup2-h150.png';
import ex5InpaintImage3 from '../../../image/for-iopaint/boy-man-sunglasses-h150.jpg';


function DiffusionOptionsDescText() {
    
    const [t] = useTranslation('translation');
  
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [hStore, hDispatch] = useHookStore();
    const { 
      // inputEta
    } = hStore.iopaintStore;

    return (
      <div className="diffsionOptionDesc">
        <div className="diffsionOptionDescRow">
          {/* {t('diffusionOptions16', 'Describe what you want to generate')} 
          {' '}({t('diffusionOptions17', 'accept English, please use translation for other languages')}) */}
          {t('inpaintEditor07', "Describe what you want to draw... (accept English, please use translation for other languages")}
          {' '}{t('promptTranslate08', 'Or, use translastion shown below')})
          <br/>
        </div>
        {/* <div className="diffsionOptionDescRow">
          <div className="diffsionOptionDescImages">
            <div>
              <img className="diffsionOptionDescImage"
                src={IpaInputImage2}
              />
              input
            </div>
            <div>
              <img className="diffsionOptionDescImage"
                src={IpaMaskImage2}
              />
              Selected
            </div>
          </div>
        </div> */}
        <div className="diffsionOptionDescRow">
          <div className="diffsionOptionDescImages">
            <div>
              <img className="diffsionOptionDescImage"
                src={ex5InputImage}
              />
              Input
            </div>
            <div>
              <img className="diffsionOptionDescImage"
                src={ex5MaskImage}
              />
              Selected
            </div>
            <div>
              <img className="diffsionOptionDescImage"
                src={ex5InpaintImage3}
              />
              a man with sunglasses
            </div>
          </div>
        </div>

        <PromptTranslate />
      </div>
    )
  }


export default DiffusionOptionsDescText;